/** Most values a KPI card shows; extra values and labels are dropped. */
export const MAX_KPI_VALUES = 6;

/** Grid columns for a KPI card with `count` values. */
export function kpiGridColumns(count: number): string {
  switch (count) {
    case 1:
      return '1fr';
    case 2:
    case 3:
      return `repeat(${count}, 1fr)`;
    case 4:
      return 'repeat(2, 1fr)';
    case 5:
    case 6:
      return 'repeat(3, 1fr)';
    default:
      return '1fr';
  }
}

/** Grid rows for a KPI card with `count` values. */
export function kpiGridRows(count: number): string {
  switch (count) {
    case 1:
    case 2:
    case 3:
      return '1fr';
    case 4:
    case 6:
      return 'repeat(2, 1fr)';
    case 5:
      return 'auto auto';
    default:
      return '1fr';
  }
}

/** The explicit grid column for a value, or undefined to let it flow. With 5 values the last 2 sit on a second row. */
export function kpiGridColumn(count: number, index: number): string | undefined {
  return count === 5 && index >= 3 ? `${index - 2} / ${index - 1}` : undefined;
}
